module.exports = __webpack_public_path__ + "img/welcome.db95dee8.png";